import React from 'react';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Box,
  Flex,
  ModalFooter,
  Divider,
} from '@chakra-ui/react';

import { Calendar, Cross } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium, TextHeader3 } from 'uiToolkitV1/Typography';

import { StyleCloseButton } from './ArchiveMeetingModal';

interface Props {
  isOpen?: boolean;
  onClose?: () => void;
  onSave?: () => void;
  isCentered?: boolean;
  employeeName?: string;
  calendarType?: string;
}

const CalendarDisconnectionModal = ({ isOpen, onClose, onSave, isCentered, calendarType }: Props) => {
  const calenderType = calendarType === 'OUTLOOK' ? 'Microsoft' : 'Google';

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={isCentered}>
      <ModalOverlay />
      <ModalContent position="relative" maxH="204px" maxW="578px">
        <ModalHeader position="relative">
          <Flex>
            <Calendar boxSize="24px" color="#333333" />
            <TextHeader3 ml="10px" bold>
              Disconnect Calendar
            </TextHeader3>
          </Flex>

          <StyleCloseButton
            variant="filled"
            color="black"
            StartIcon={(props) => <Cross {...props} boxSize="20px" />}
            onClick={onClose}
          />
        </ModalHeader>
        <Divider opacity={1} color="#EBEFF3" />

        <ModalBody p="26px 30px">
          <Box display="flex">
            <TextBodyMedium>
              {`This will remove all your existing 1:1’s from your calendar. Are you sure you want to disconnect from  ${calenderType} calendar?`}
            </TextBodyMedium>
          </Box>
        </ModalBody>
        <ModalFooter
          sx={{
            background: '#F5F7F9',
            borderTop: '1px solid #CED7DF',
            borderRadius: '0px 0px 8px 8px',
          }}
        >
          <Button
            sx={{
              '&>p': {
                marginLeft: 0,
              },
            }}
            mr="auto"
            variant="tertiary"
            onClick={onClose}
          >
            No
          </Button>
          <Button onClick={onSave}>Yes</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export { CalendarDisconnectionModal };
